export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-20.4b27dcd1.png";